import React 			from 'react'
import renderHTML 		from 'react-render-html'
import {
	get
} from 'lodash'

import ARYImage 		from '../ary-image'
import PageLayout 		from '../page-layout'
import SectionSpacer 	from '../section-spacer'
import SectionWrap 		from '../section-wrap'
import StoryLength 		from '../story-length'
import {
	TextBlock,
	TextBlockIntro
} from '../text-block'
import Video 			from '../video'

import Components 		from './components'
import map 				from './map'

import Section 			from './components/section'

import {
	formatImageForARYImage
} from '../../lib/_helpers'

const ArticleSection = (props) => {
	const {
		acf_fc_layout,
		__typename
	} = props

	const fcLayout = !__typename && acf_fc_layout
	const type = fcLayout ? `WordPressAcf_${ acf_fc_layout }` : __typename
	const key = map[type]
	
	let Component = get(Components, key)

	if(Component){
		return <Component
			{ ...props }
			/>
	} else {
		return null
	}
}

export const ArticleSections = ({ content, spaceFirst }) => {
	return content && content.length > 0 ? content.map((_section, _i) => {
		return <React.Fragment
			key={ _i }>
			{ _i > 0 || spaceFirst ? <SectionSpacer /> : null }
			<ArticleSection
				{ ..._section }
				/>
		</React.Fragment>
	}) : null
}

export default (props) => {
	const {
		page,
		location
	} = props

	if(!page){ return null }

	const {
		acf,
		title
	} = page

	const content = get(acf, 'article_content_post')
	const main = get(acf, 'main')
	const mainDisplay = get(main, 'display')
	const mainContent = mainDisplay === 'image' ? formatImageForARYImage(get(main, 'image')) : get(main, 'video')
	const hasMain = main && mainContent

	return <PageLayout
		siteTitle={ `${ title } — Endomag` }
		siteDescription={ null }
		location={ location }>
		{ title || hasMain ? <SectionWrap
				className="pageArticle-lead"
				spaceBottom={ 0 }>
				<div className="cont">
					{ title ? <TextBlock
						type="intro">
						<h1 className="p--h2">{ title }</h1>
					</TextBlock> : null }
					{ hasMain ? <React.Fragment>
							<SectionSpacer space={ 0.5 } />
							<div className="pageArticle-main">
								{ mainDisplay === 'image' ? <div className="pageArticle-main-image">
										<ARYImage
											image={ mainContent }
											/>
									</div> : mainDisplay === 'video' ? <Video
										video={ mainContent }
										/> : null }
							</div>
						</React.Fragment> : null }
				</div>
			</SectionWrap> : null }
		<SectionWrap>
			<div className="cont">
				<div className="cols">
					<div className="col col--1-4">
						<TextBlock>
							<h4>{ title }</h4>
							<StoryLength
								post={ page }
								/>
						</TextBlock>
					</div>
					<div className="col col--3-4">
						{ acf.introduction ? <Section
							type="introduction"
							indent={ true }
							>
							<TextBlock
								type="largest">
								{ renderHTML(acf.introduction) }
							</TextBlock>
						</Section> : null }
						<ArticleSections
							content={ content }
							spaceFirst={ !!acf.introduction }
							/>
					</div>
				</div>
			</div>
		</SectionWrap>
	</PageLayout>
}